/* KOCHASH – alttan çıkan yapışkan sepet çubuğu */
if (!customElements.get('kc-sticky-atc')) {
  customElements.define(
    'kc-sticky-atc',
    class KcStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainForm = document.querySelector('product-info form[data-type="add-to-cart-form"]');
        if (!this.mainForm) return;
        this.mainButton = this.mainForm.querySelector('[name="add"]');
        this.button = this.querySelector('[data-kc-sticky-btn]');
        this.priceEl = this.querySelector('[data-kc-sticky-price]');

        const info = this.mainForm.closest('product-info');
        this.button.dataset.label = this.button.textContent.trim();
        this.hidden = false;
        this.button.addEventListener('click', () => {
          if (this.mainButton && !this.mainButton.disabled) {
            this.mainButton.click();
          } else if (this.mainForm) {
            this.mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

        if ('IntersectionObserver' in window && this.mainButton) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.classList.toggle('is-visible', passed);
                document.body.classList.toggle('kc-sticky-open', passed);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(this.mainButton);
        }

        this.sync = this.sync.bind(this);
        const priceWrap = info ? info.querySelector('[id^="price-"]') : null;
        if (priceWrap) {
          this.mutation = new MutationObserver(this.sync);
          this.mutation.observe(priceWrap, { childList: true, subtree: true, characterData: true });
        }
        if (this.mainButton) {
          this.btnObserver = new MutationObserver(this.sync);
          this.btnObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'] });
        }
      }

      sync() {
        const info = this.mainForm && this.mainForm.closest('product-info');
        if (info) {
          const sale = info.querySelector('[id^="price-"] .price--on-sale .price-item--sale');
          const regular = info.querySelector('[id^="price-"] .price__regular .price-item--regular');
          const source = sale || regular;
          if (source && this.priceEl) this.priceEl.textContent = source.textContent.trim();
        }
        this.mainButton = this.mainForm.querySelector('[name="add"]');
        if (this.mainButton) {
          this.button.disabled = this.mainButton.disabled;
          this.button.textContent = this.mainButton.disabled
            ? this.mainButton.textContent.trim()
            : this.button.dataset.label || this.button.textContent;
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutation) this.mutation.disconnect();
        if (this.btnObserver) this.btnObserver.disconnect();
      }
    }
  );
}
